import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)

export function createRouter () {
  
  return new Router({
    mode: 'history',
    routes,
    scrollBehavior (to, from, savedPosition) { 
      if(!to.hash) {
        $('.v-application').scrollTop(0);
        $('#app-content').scrollTop(0);
        $('html').scrollTop(0);
      } else {
        $(to.hash)[0].scrollIntoView();
      }
      // document.getElementById('app-content_mobile').scrollTop(0);
      // document.getElementById('app-content').scrollTop(0);
    }
  })
}



// WEBPACK FOOTER //
// ./src/router/index.js